<template>
  <div class="tsjy">
    <template v-for="item in list">
      <div :key="item.id" class="content" style="">
        <div>
          <a class="tsCon tsCon1 l11" href="/shoptsdetail">
            <div class="tsDiv">
              <div class="qaValue">
                <div class="texts">
                  <div class="section">
                    <span>提交时间：{{ item.createDate }}</span>
                    <span class="statustxt">{{ item.dealStatus.label }}</span>
                  </div>
                </div>
                <div class="line"></div>
                <div class="texts">
                  <ul class="ms msa">
                    <li>其他</li>
                    <li>{{ item.content }}</li>
                    <li v-for="(item2, index2) in item.gallery" :key="index2">
                      <img :src="item2" style="width:100%;" />
                    </li>
                  </ul>
                </div>
                <div class="texts">
                  <div class="section">
                    <span>处理时间{{ item.dealDate }}</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <div class="h10"></div>
        </div>
      </div>
    </template>
    <!-- <div class="content" style="">
      <div>
        <a class="tsCon tsCon1 l11" href="/shoptsdetail">
          <div class="tsDiv">
            <div class="qaValue">
              <div class="texts">
                <div class="section">
                  <span>提交时间：2022-01-24</span>
                  <span class="statustxt">待受理</span>
                </div>
              </div>
              <div class="line"></div>
              <div class="texts">
                <ul class="ms msa">
                  <li>其他</li>
                  <li>你好，请问都有什么价位的？</li>
                </ul>
              </div>
            </div>
          </div>
        </a>
        <div class="h10"></div>
      </div>
    </div> -->
    <!-- <div class="content" style="">
      <div>
        <a class="tsCon tsCon1 l11" href="/shoptsdetail">
          <div class="tsDiv">
            <div class="qaValue">
              <div class="texts">
                <div class="section">
                  <span>提交时间：2022-01-24</span>
                  <span class="statustxt">受理中</span>
                </div>
              </div>
              <div class="line"></div>
              <div class="texts">
                <ul class="ms msa">
                  <li>其他</li>
                  <li>你好，请问都有什么价位的？</li>
                  <li>
                    <img src="../../assets/search1.jpg" style="width:100%;" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </a>
        <div class="h10"></div>
      </div>
    </div> -->
    <div class="submitTs">
      <a href="/shoptsjysub">
        <div>添加投诉建议</div>
      </a>
    </div>
  </div>
</template>

<script>
import bus from '../../common/bus'
export default {
  name: 'tousuyijian',
  data() {
    return {
      list: [],
    }
  },
  created() {
    bus.$emit('menuClick', 2)
    this.getData()
  },
  mounted() {
    bus.$emit('menuClick', 2)
  },
  methods: {
    getData() {
      var that = this
      this.$queryPage(
        'MsgSuggestion',
        {},
        [
          'id',
          'category',
          'content',
          'gallery',
          'dealStatus',
          'dealDate',
          'dealResult',
          'createDate',
        ],
        function(res) {
          that.$fill(that.list, res.data)
        }
      )
    },
  },
}
</script>

<style>
.content {
  padding: 1rem;
  font-size: 1.6rem;
}
.l11 {
  height: 100%;
}
.tsCon {
  background-color: #fff;
  box-sizing: border-box;
  color: inherit;
  min-height: 48px;
  display: block;
  overflow: hidden;
  position: relative;
  text-decoration: none;
}
.tsCon1 .tsCon-left,
.tsCon1 .tsCon-right,
.tsCon1 .tsDiv {
  transition: transform 0.15s ease-in-out;
}
.tsCon-left {
  position: absolute;
  height: 100%;
  left: 0;
  transform: translate3d(-100%, 0, 0);
}
.tsCon1-buttongroup {
  height: 100%;
}

.tsCon:first-child .tsDiv {
  background-origin: border-box;
}

.l11 .tsDiv {
  padding: 0;
}

.l11 .tsDiv {
  padding: 0;
}
.l11 .tsCon-title {
  display: none;
}

.l11 .tsCon-title {
  display: none;
}
.tsCon-title {
  -ms-flex: 1;
  flex: 1;
}

.l11 .qaValue {
  width: 100%;
  display: block;
}

.l11 .qaValue {
  width: 100%;
  display: block;
}
.qaValue {
  color: #888;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}
.texts {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.texts .section {
  position: relative;
  font-size: 1.4rem;
  height: 4.8rem;
  line-height: 4.8rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}
.texts .section span {
  color: #15a892;
}
.texts .section span.statustxt {
  color: #15a892 !important;
  font-weight: bolder;
}

.texts .section span {
  color: #15a892;
}
.line {
  width: 100%;
  border-bottom: 1px solid #eee;
}
.texts {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.texts ul.msa {
  padding-top: 1.5rem;
  padding-bottom: 0.8rem;
}
.texts ul.ms {
  padding-top: 1.5rem;
  padding-bottom: 0.2rem;
}
.texts ul.msa > li {
  padding-bottom: 1.5rem;
}

.texts ul.ms > li {
  width: 100%;
  color: #323232;
  font-size: 1.4rem;
  line-height: 2rem;
  padding-bottom: 1.1rem;
  display: flex;
  justify-content: flex-start;
}
.texts ul.msa > li {
  padding-bottom: 1.5rem;
}

.texts ul.ms > li {
  width: 100%;
  color: #323232;
  font-size: 1.4rem;
  line-height: 2rem;
  padding-bottom: 1.1rem;
  display: flex;
  justify-content: flex-start;
}
.submitTs {
  width: 100%;
  height: 3.9rem;
  background-color: #15a892;
  font-size: 1.4rem;
  color: #fff;
  text-align: center;
  padding-top: 1.2rem;
  position: fixed;
  bottom: 5rem;
}
.submitTs div {
  color: #fff;
}
</style>
